import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';
import AppImage from '../../../components/openplay/OpenPlayImage';

const ParticipantList = ({ participants, maxParticipants }) => {
  const emptySlots = maxParticipants - participants.length;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-foreground flex items-center gap-2">
          <Icon name="UserGroupIcon" size={20} className="text-primary" />
          참가자 목록
        </h3>
        <span className="text-sm text-muted-foreground caption">
          {participants.length} / {maxParticipants}명
        </span>
      </div>

      <div className="space-y-3">
        {participants.map((participant) => (
          <div
            key={participant.id}
            className="flex items-center gap-3 p-3 rounded-lg bg-muted hover:bg-muted/80 transition-smooth"
          >
            <div className="w-12 h-12 rounded-full overflow-hidden bg-background flex-shrink-0">
              <AppImage src={participant.avatar} alt={participant.avatarAlt} className="w-full h-full object-cover" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-foreground mb-0.5 truncate">{participant.name}</p>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <span className="caption">{participant.skillLevel}</span>
                <span>·</span>
                <span className="caption">{participant.joinedDate}</span>
              </div>
            </div>
            <Icon name="CheckBadgeIcon" variant="solid" size={20} className="text-success flex-shrink-0" />
          </div>
        ))}

        {emptySlots > 0 && (
          <>
            {Array.from({ length: Math.min(emptySlots, 3) }).map((_, index) => (
              <div
                key={`empty-${index}`}
                className="flex items-center gap-3 p-3 rounded-lg border-2 border-dashed border-border"
              >
                <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center flex-shrink-0">
                  <Icon name="UserPlusIcon" size={24} className="text-muted-foreground" />
                </div>
                <div className="flex-1">
                  <p className="text-sm text-muted-foreground caption">참가 가능</p>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default ParticipantList;
